import { RoutesComponents } from "@/components/app/RoutesComponents";
import { PortableVideo } from "components/UI/PortableVideo";
import { useLessNavigation } from "@/common/hooks/useLessNavigation";
import { AppNotification } from "./AppNotification";
import "./AppContent.scss";

export const AppContent = () => {
  const { canShow } = useLessNavigation();

  return (
    <div className="Wrapper">
      <div className="routeWrapper">
        {canShow && <AppNotification />}
        <PortableVideo />
        <RoutesComponents />
      </div>
    </div>
  );
};
